<template>
  <v-container fluid class="pa-0">
    <HalfCircleSpinner :isLoading="isLoading" />
    <AppBar :isFixed="false" />
    <v-card
      v-if="!isLoading"
      :elevation="$vuetify?.breakpoint?.smAndDown ? 0 : 3"
      :style="{
        margin: $vuetify?.breakpoint?.smAndDown ? '0' : '5rem 15rem',
      }"
    >
      <v-row class="d-flex justify-center">
        <v-col cols="12" sm="10" md="10" lg="10">
          <div
            :class="[
              $vuetify.breakpoint.xs ? 'text-body-2' : 'text-subtitle-1',
            ]"
          >
            <div class="sake-brewery-small-logo__container mx-auto mb-8">
              <v-img
                :src="SakeBreweryTopLogo"
                alt="sake brewery name(i.e., sakagura)"
                contain
              >
              </v-img>
            </div>
            <h2
              class="mb-6 mt-4 font-weight-bold text-center green-heading-text"
            >
              あなたのタイプ
            </h2>
            <div>
              <div>
                <p class="random-comment">
                  {{ `${displayTasteProfileDetails.comment}` }}
                </p>
              </div>
              <div class="pattern-type">
                <div>
                  <p style="margin: 0 0 2rem 0;">{{ displayTasteProfileDetails.name }}</p>
                </div>
                
                <div>
                  <v-img
                  :src="staticImagesPathGenerator('character_images', tasteClassification[displayTasteProfileDetails.result].character_image)"
                  :alt="staticImagesPathGenerator('character_images', tasteClassification[displayTasteProfileDetails.result].character_image)"
                  height="12rem"
                  contain
                  ></v-img>
                </div>

                <div>
                  <v-img
                    v-if="displayTasteProfileDetails.name"
                    :src="
                      staticImagesPathGenerator(
                        'pattern_images_without_title',
                        `${displayTasteProfileDetails.name}.jpg`
                      )
                    "
                    :alt="displayTasteProfileDetails.name"
                    height="20rem"
                    contain
                  ></v-img>
                </div>
              </div>
            </div>

            <div class="mb-2 text-center">
              <h2 class="green-heading-text mb-6 mt-2 mt-md-4 font-weight-bold">
                タイプの特徴
              </h2>
              <v-row justify="center">
                <v-col cols="auto" class="d-flex flex-column align-center">
                  <ul class="taste-characteristics">
                    <li
                      v-for="(
                        item, index
                      ) in displayTasteProfileDetails.characteristics"
                      :key="index"
                      class="text-center mb-4"
                    >
                      ＊ {{ item }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </div>
            <div>
              <p
                class="mt-3 mt-md-4 pa-4 profile-explanation"
                style="background-color: #dfedc9"
              >
                {{ displayTasteProfileDetails.explanation }}
              </p>
              <!-- <v-divider></v-divider>
                <template>
                  <v-container>
                    <v-row class="d-flex justify-end">
                      <v-dialog v-model="showFeedbackTextArea" max-width="600px">
                        <v-card>
                          <v-card-title>
                            <span>
                              <v-icon v-if="thumbsUp"
                                >mdi-thumb-up-outline</v-icon
                              >
                              <v-icon v-else>mdi-thumb-down-outline</v-icon>
                            </span>
                            フィードバック
                            <v-spacer></v-spacer>
                             <v-menu bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                              </v-menu>
                          </v-card-title>
                          <v-card-text class="pb-0">
                            <v-textarea
                              v-model="feedbackText"
                              name="positive feedback"
                              outlined
                              auto-grow
                              :placeholder="
                                thumbsUp
                                  ? 'ご意見やご要望がございましたら、お気軽にお知らせください。'
                                  : 'ご意見やご要望がございましたら、お気軽にお知らせください。'
                              "
                            ></v-textarea>
                          </v-card-text>
                          <v-card-actions class="py-4">
                            <v-spacer></v-spacer>
                            <v-btn
                              color="#006934"
                              @click="proceedWithFeedbackText"
                              dark
                            >
                              送信
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-btn
                        color="#006934"
                        class="ma-2"
                        dark
                        icon
                        @click="handleThumbsUp"
                      >
                        <v-icon>{{
                          thumbsUp ? "mdi-thumb-up" : "mdi-thumb-up-outline"
                        }}</v-icon>
                      </v-btn>
                      <v-btn
                        color="#006934"
                        class="ma-2"
                        dark
                        icon
                        @click="handleThumbsDown"
                      >
                        <v-icon>{{
                          thumbsDown ? "mdi-thumb-down" : "mdi-thumb-down-outline"
                        }}</v-icon>
                      </v-btn>
                    </v-row>
                  </v-container>
                </template> -->
            </div>
            <!-- <div class="d-flex flex-column align-center justify-center">
              <v-chip-group
                v-for="(values, type) in displayTasteProfileDetails"
                :key="type"
                class="me-1 me-sm-2 text-center"
                column
                multiple
              >
                <div class="text-center">
                  
                  <h2
                    v-if="type == 'tasteCategoryTypes' && values.length > 0"
                    :class="[$vuetify.breakpoint.xs ? 'mb-2' : 'mb-0']"
                    class="green-heading-text mb-2 font-weight-bold text-center"
                  >
                    おすすめの日本酒の味
                  </h2>
                 
                  <h2
                    v-if="
                      type == 'manufacturingCategoryTypes' && values.length > 0
                    "
                    :class="[$vuetify.breakpoint.xs ? 'mb-2' : 'mb-0']"
                    class="green-heading-text mb-2 font-weight-bold text-center"
                  >
                    おすすめの日本酒の種類
                  </h2>
                  
                  <div
                    :class="[
                      'mb-6 d-flex flex-wrap justify-center align-center font-weight-bold',
                      $vuetify?.breakpoint?.smAndDown ? 'flex-column' : '',
                    ]"
                  >
                    <v-chip
                      v-for="value in values"
                      :key="value"
                      outlined
                      small
                      :class="[$vuetify.breakpoint.xs ? 'small' : '']"
                      class="ma-1 px-4 py-2"
                      style="font-size: 17px"
                    >
                      {{ value }}
                    </v-chip>
                  </div>
                </div>
              </v-chip-group>
            </div> -->
            <div class="d-flex flex-column align-center justify-center">
              <!-- Taste Category Types -->
              <div
                v-if="
                  displayTasteProfileDetails.tasteCategoryTypes &&
                  displayTasteProfileDetails.tasteCategoryTypes.length > 0
                "
                class="text-center mb-6"
              >
                <h2
                  :class="[$vuetify.breakpoint.xs ? 'mb-2' : 'mb-0']"
                  class="green-heading-text mb-2 font-weight-bold text-center"
                >
                  おすすめの日本酒の味
                </h2>
                <div
                  :class="[
                    'd-flex flex-wrap justify-center align-center font-weight-bold',
                    $vuetify?.breakpoint?.smAndDown ? 'flex-column' : '',
                  ]"
                >
                  <v-chip
                    v-for="value in displayTasteProfileDetails.tasteCategoryTypes"
                    :key="value"
                    outlined
                    small
                    :class="[$vuetify.breakpoint.xs ? 'small' : '']"
                    class="ma-1 px-4 py-2"
                    style="font-size: 17px"
                  >
                    {{ value }}
                  </v-chip>
                </div>
              </div>

              <!-- Manufacturing Category Types -->
              <div
                v-if="
                  displayTasteProfileDetails.manufacturingCategoryTypes &&
                  displayTasteProfileDetails.manufacturingCategoryTypes.length >
                    0
                "
                class="text-center mb-6"
              >
                <h2
                  :class="[$vuetify.breakpoint.xs ? 'mb-2' : 'mb-0']"
                  class="green-heading-text mb-2 font-weight-bold text-center"
                >
                  おすすめの日本酒の種類
                </h2>
                <div
                  :class="[
                    'd-flex flex-wrap justify-center align-center font-weight-bold',
                    $vuetify?.breakpoint?.smAndDown ? 'flex-column' : '',
                  ]"
                >
                  <v-chip
                    v-for="value in displayTasteProfileDetails.manufacturingCategoryTypes"
                    :key="value"
                    outlined
                    small
                    :class="[$vuetify.breakpoint.xs ? 'small' : '']"
                    class="ma-1 px-4 py-2"
                    style="font-size: 17px"
                  >
                    {{ value }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <div
        v-for="(allProducts, category) in displayRecommendedProducts"
        :key="category"
      >
        <h2 class="mb-6 my-4 text-center green-heading-text">菊水のおすすめ</h2>
        <v-row class="d-flex justify-center mx-1">
          <v-col
            v-for="product in allProducts"
            :key="product?.item_id"
            cols="12"
            sm="10"
            md="11"
            lg="11"
          >
            <ProductCard
              :id="product?.item_id"
              :name="product?.title"
              :item_image="product?.image_url"
              :price="product?.price"
              :description="product?.description"
              :tasteType="[product?.flavour_type.join('・')]"
              :ingredientType="[product?.variant.join('・')]"
              :volume="product?.volume"
              :volumeVariant="product?.volume_variant"
              :childItems="displayChildItems?.[product?.item_id]"
              :recommendedWayToDrink="product?.recommended_way_to_consume"
              :recommendedJapaneseFood="product?.japanese_food"
              :recommendedWesternFood="product?.western_food"
              :recommendedChineseAndEthnicFood="
                product?.chinese_and_ethnic_food
              "
              :recommendedSweetsAndFruit="product?.sweets_and_fruit"
            />
          </v-col>
        </v-row>
      </div>
      <div>
        <v-row class="d-flex justify-center align-center my-8" dense>
          <v-btn
            class="mx-2"
            :small="$vuetify.breakpoint.smAndDown"
            color="#355b91"
            dark
            @click="shareOnFacebook"
          >
            <v-icon left>mdi-facebook</v-icon>
            シェア
          </v-btn>

          <v-btn
            class="mx-2"
            :small="$vuetify.breakpoint.smAndDown"
            color="#398bb1"
            dark
            @click="shareOnTwitter"
          >
            <v-icon left>mdi-twitter</v-icon>
            ツイート
          </v-btn>

          <v-btn
            :small="$vuetify.breakpoint.smAndDown"
            class="mx-2"
            color="#309c43"
            dark
            @click="shareOnLine"
          >
            <v-icon left>mdi-chat-outline</v-icon>
            LINEで送る
          </v-btn>
        </v-row>
      </div>
      <div>
        <v-row class="d-flex justify-center align-center px-10">
          <v-col cols="12" md="10" lg="10">
            <v-btn
              class="mt-12 mb-10 py-6 font-weight-medium"
              @click="resetSurvey"
              rounded
              dark
              block
              color="#006934"
              :small="$vuetify?.breakpoint?.smAndDown"
              :style="{
                fontSize: $vuetify?.breakpoint?.smAndDown ? '18px' : '23px',
              }"
            >
              <b>蔵酒 MATCH で診断する</b>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <!-- <v-footer class="footer-section">
      <div style="width: 100%; background-color: #b6afab">
        <p class="text-center py-4 ma-0">
          Produced by Taste & Aroma Strategic Research Institute Co.,Ltd.
        </p>
      </div>
    </v-footer> -->
    <FooterSection :isFixed="false" v-show="!isLoading" />
  </v-container>
</template>
<script>
import CryptoJS from "crypto-js";
import {
  encryptData,
  decryptData,
  generateShareableLink,
  extractDataFromToken,
} from "@/utils/encryptedShareableLink";
import { mapGetters } from "vuex";
import ProductCard from "@/components/ProductCard.vue";
import SakeBreweryTopLogo from "@/assets/sakagura_top_logo.png";
import {
  fetchQuestionnaireLogs,
  fetchConversation,
  fetchChildItems,
} from "@/utils/apiServices";
import {
  processToDisplayRecommendationItems,
  extractGptResponse,
  mappingRecommendationKeys,
  selectTop3Categories,
  processToDisplayTasteProfileDetails,
  staticImagesPathGenerator,
} from "@/utils/recommendationItemsHelpers";
import { tasteClassification } from "@/utils/tasteClassificationInfo";
import HalfCircleSpinner from "@/components/HalfCircleSpinner.vue";
import AppBar from "@/components/AppBar.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "RecommendedItemsPage",
  metaInfo() {
    return {
      title: "蔵酒 Match - Recommended Items",
      meta: [
        { property: "og:title", content: "蔵酒 Match - Recommended Items" },
        {
          property: "og:description",
          content: "Your personalized sake recommendations via Gigalogy",
        },
        {
          property: "og:url",
          content:
            "https://kurazake-match.gigalogy.com/recommended-items",
        },
        {
          property: "og:image",
          content: "https://kurazake-match.gigalogy.com/ogp1.png",
        },
      ],
    };
  },
  components: {
    AppBar,
    FooterSection,
    ProductCard,
    HalfCircleSpinner,
  },
  data() {
    return {
      SakeBreweryTopLogo,
      displayRecommendedProducts: {},
      displayTasteProfileDetails: {},
      displayChildItems: {},
      isLoading: true,
      tasteClassification: tasteClassification,
    };
  },
  beforeCreate() {},
  created() {
    this.fetchComponentData();
  },
  mounted() {},
  computed: {
    ...mapGetters("credentials_form", ["credentialsFromData"]),
  },
  methods: {
    staticImagesPathGenerator,
    resetSurvey() {
      this.$router.push("/");
    },
    async fetchComponentData() {
      const token = this.$route.query.token;
      const { userId, requestId, conversationId, limit, commentIndex } =
        extractDataFromToken(token);
      const { projectKey, apiKey, questionnaireId } = this.credentialsFromData;
      try {
        // Call both APIs simultaneously
        const [questionnaireResponse, conversationResponse] = await Promise.all(
          [
            fetchQuestionnaireLogs(
              projectKey,
              apiKey,
              questionnaireId,
              requestId,
              userId
            ),
            fetchConversation(projectKey, apiKey, conversationId),
          ]
        );
        const questionnaiRecommendations =
          questionnaireResponse.logs.recommendation_log[0].response.detail
            .recommendations;
        const gptResponse = conversationResponse.detail.response.response;

        // processing the data
        const gptExtractedData = await extractGptResponse(gptResponse);
        const processedRecommendations = await mappingRecommendationKeys(
          questionnaiRecommendations
        );
        const top3Categories = await selectTop3Categories(
          processedRecommendations,
          gptExtractedData.preferredCategories
        );
        const recommendationItems = await processToDisplayRecommendationItems(
          processedRecommendations,
          top3Categories,
          limit
        );

        // Displaying the data
        this.displayTasteProfileDetails =
          await processToDisplayTasteProfileDetails(
            gptExtractedData,
            tasteClassification,
            recommendationItems,
            commentIndex
          );
        this.displayRecommendedProducts = recommendationItems;
        this.displayChildItems = await fetchChildItems(
          { projectKey, apiKey },
          recommendationItems
        );
        // Set loading to false after all data is processed
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.error("Error in fetchComponentData:", error.message);
        throw error;
      }
    },

    shareOnFacebook() {
      const url = window.location.href;
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}`;
      const newWindow = window.open(
        shareUrl,
        "facebook-share-dialog",
        "width=626,height=436"
      );
      if (newWindow) {
        newWindow.focus();
      } else {
        window.location.href = shareUrl;
      }
    },

    shareOnTwitter() {
      const url = window.location.href;
      const title = document.title;
      const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        title
      )}&url=${encodeURIComponent(url)}&via=Gigalogy&hashtags=蔵酒Match`;

      window.open(shareUrl, "twitter-share-dialog", "width=626,height=436");
    },

    shareOnLine() {
      const url = window.location.href;
      const shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        url
      )}`;
      window.open(shareUrl, "line-share-dialog", "width=626,height=436");
    },
  },
};
</script>

<style scoped>
.footer-section {
  background-color: transparent !important;
  font-size: 13px;
  padding: 0px;
  margin: 0px;
  z-index: 0;
}

.profile-explanation {
  font-weight: bold;
  line-height: 1.6rem;
}

.home-container {
  padding: 2.5rem 0 0 0;
}
.green-heading-text {
  color: #006934;
}
.sake-brewery-small-logo__container {
  width: 7.5rem;
  margin: 0 auto;
}
.questionnaire-content {
  padding: 0px;
}
.progressbar__container {
  margin: 0 auto;
  width: 43.75rem;
}
.stepper-form {
  margin: 0 1.563rem;
}
.stepper-content {
  margin: 1.5rem 0 0 0;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.taste-characteristics {
  text-align: center;
  padding: 0;
  font-weight: 800;
  list-style-type: none;
  padding-left: 0;
  font-size: 1.313rem;
}
.diagnose-brewery-logo__container {
  z-index: 1;
  width: 21.25rem;
}

.kurazake-title {
  font-size: 24px;
  font-weight: 500;
  display: block;
  margin: 0;
}

.diagnose-button {
  z-index: 1;
  font-size: 18px;
}

.v-progress-linear {
  transition: width ease-in-out;
}
.random-comment,
.pattern-type {
  font-size: 1.875rem !important;
  line-height: 1;
  text-align: center;
  font-weight: 800;
}
.pattern-type p {
  margin-bottom: 0;
}
.hvr-shutter-out-horizontal {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  background: transparent;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.hvr-shutter-out-horizontal:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2098d1;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: 50%;
  transform-origin: 50%;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.hvr-shutter-out-horizontal.active {
  color: white;
}

.hvr-shutter-out-horizontal.active:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

.hvr-sweep-to-right {
  padding: 20px;
  background: lightgrey;
  display: inline-block;
  transform: perspective(1px) translateZ(0);
  position: relative;
  transition: color 0.3s;
}

.hvr-sweep-to-right:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #2098d1;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition: transform 0.3s ease-out;
}

.hvr-sweep-to-right.active {
  color: white;
}

.hvr-sweep-to-right.active:before {
  transform: scaleX(1);
}

.taste-profile-start-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  font-size: 18px;
}

.continue-btn {
  padding: 5px 20px;
  background: transparent;
  color: white;
  border: 1px solid whitesmoke;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 20px;
}

.continue-btn:hover {
  background: linear-gradient(to right, #07f7f7, transparent);
}

.questionnaire-container {
}

.questionnaire-title {
  font-size: var(--title-font-size-desktop) !important;
  transition: all 0.3s ease;
  padding: 16px 20px !important;
}

.v-card__title {
  display: block !important;
}

.question-text {
  font-size: 1.5rem;
  transition: all 0.3s ease;
  line-height: 1.2 !important;
}

.option-text {
  font-size: 1.25rem !important;
  transition: all 0.3s ease;
  line-height: 1.2 !important;
}

.v-slide-group__content {
  display: block !important;
}

/* Mobile devices (max-width 600px is Vuetify's default breakpoint for mobile) */
@media screen and (max-width: 600px) {
  .diagnose-brewery-logo__container {
    z-index: 1;
    width: 70%;
    margin: 0 auto;
  }
  .kurazake-title {
    font-size: 22px;
  }
  .diagnose-button {
    z-index: 1;
    font-size: 16px;
    font-weight: bold;
    width: 80%;
  }
  .next-button {
    font-size: 16px;
    width: 90%;
  }
  .random-comment,
  .pattern-type {
    font-size: 1.25rem;
  }
  .progressbar__container {
    width: 90%;
  }
  .questionnaire-title {
    padding: 12px !important;
  }
  .question-text {
    font-size: 1.3rem !important;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
  .taste-characteristics {
    font-size: 1.25rem;
  }
  .stepper-content {
    margin: 0 !important;
  }
  .option-text {
    font-weight: bold;
    margin: 10px;
  }
  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 12px !important;
  }
  .v-stepper__content {
    padding: 16px 10px !important;
  }
  .custom-dropdown .v-input__control {
    border: 2px solid #b6afab;
    border-radius: 12px;
    padding: 6px 16px;
  }

  .custom-dropdown input {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }

  .stepper-form {
    margin: 0 !important;
  }
}
</style>
